import React, { useEffect, useState } from "react";
import PT from "prop-types";
import { sendOtp, resetPassword } from "@quintype/bridgekeeper-js";

import EditIcon from "../../atoms/EditIcon";
import EyeClose from "../../atoms/EyeCloseIcon";
import EyeOpen from "../../atoms/EyeOpenIcon";

import { useTimer } from "../../atoms/timer";
import "./forms.m.css";

const ResetPassword = ({ userInfo, setActiveTab, setLoading }) => {
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [otpVisible, setOtpVisible] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [data, setOTPData] = useState({
    otp: "",
    password: "",
  });

  const { start, time } = useTimer();
  const wrongOtpError = ({ action, errorMsg }) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_signup_error",
        event_action: action,
        error_message: errorMsg,
      });
    }
  };

  useEffect(() => {
    start(180);
  }, []);

  const changePassword = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (data.otp.trim().length < 5) {
      setError("Please enter valid otp !");
      wrongOtpError({ action: "wrong_otp", errorMsg: "Please enter valid otp !" });
      return;
    }

    if (!data.password) {
      setError("Password can't be empty !");
      return;
    }

    const resObj = {
      email: userInfo.email,
      otp: data.otp.trim(),
      "new-password": data.password,
    };

    setLoading(true);

    resetPassword(resObj)
      .then((res) => {
        if (res.error) {
          setError(res.error.message);
          wrongOtpError({ action: "wrong_otp", errorMsg: res.error.message });
          return;
        }

        setSuccessMsg("Password changed successfully. Please login");
        if (typeof window !== "undefined" && window.dataLayer) {
          window.dataLayer.push({
            event: "dl_forgotpwd_steps",
            event_action: "verify_signin_click",
          });
        }

        setActiveTab("login");
      })
      .catch((err) => {
        setError("Something went wrong!");
        console.error("error", err);
        wrongOtpError({ action: "reset_password", errorMsg: err });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setData = (e) => {
    const userObj = { ...data };
    const fieldName = e.target.id;
    userObj[fieldName] = e.target.value;
    setOTPData(userObj);
  };

  const resendOTP = async () => {
    const data = {
      email: userInfo.email,
    };
    try {
      start(180);
      const res = await sendOtp(data);
      if (res.status === 200) {
        setSuccessMsg(`OTP Sent to your registered email`);
      } else {
        setError(res.error || res);
        wrongOtpError({ action: "wrong_resend_otp", errorMsg: res.error });
      }
    } catch (error) {
      setError(error);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <div styleName="auth-container otpContainer">
      <h2 styleName="title">
        Enter the OTP for {userInfo.email}
        <span styleName="email">
          <EditIcon />
        </span>
      </h2>

      <form onSubmit={changePassword} styleName="form">
        <label htmlFor="otp" styleName="auth-label">
          Enter OTP
        </label>
        <div styleName="otpInputContainer">
          <input
            type={otpVisible ? "text" : "password"}
            id="otp"
            name="Enter OTP"
            value={data.otp}
            onChange={setData}
            onFocus={() => setError("")}
            placeholder="Enter OTP"
            required
            maxLength={6}
            styleName="auth-input"
          />
          <button type="button" styleName="toggleButton" onClick={() => setOtpVisible(!otpVisible)}>
            {otpVisible ? <EyeClose /> : <EyeOpen />}
          </button>
        </div>

        {time === 0 ? (
          <button type="button" onClick={resendOTP} styleName="resendButton">
            Resend OTP
          </button>
        ) : (
          <p styleName="resendText">
            Resend OTP in <span styleName="timer">{formatTime(time)}</span>
          </p>
        )}

        <label htmlFor="newPassword" styleName="auth-label">
          New Password
        </label>
        <div styleName="otpInputContainer new-password">
          <input
            type={passwordVisible ? "text" : "password"}
            id="password"
            name="password"
            value={data.password}
            onChange={setData}
            placeholder="Enter new password"
            required
            styleName="auth-input"
          />
          <button type="button" styleName="toggleButton" onClick={() => setPasswordVisible(!passwordVisible)}>
            {passwordVisible ? <EyeClose /> : <EyeOpen />}
          </button>
        </div>

        {successMsg && <p>{successMsg}</p>}
        {error && <p styleName="error">{error}</p>}

        <button type="submit" styleName="submit-button">
          Verify & Sign In
        </button>
      </form>
    </div>
  );
};

ResetPassword.propTypes = {
  member: PT.object,
  customCallbackUrl: PT.string,
  onSignup: PT.func,
  userInfo: PT.object,
  setActiveTab: PT.func,
  setLoading: PT.func,
};

export { ResetPassword };
